import React, {useEffect} from 'react';
import {Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDoesUserHaveAccessToModule,
    bbIsBetasOk,
    getFirstCustomerId,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import MultiBoardWrapper from "../cirt/routes/MultiBoardWrapper";
import {fetchCustomers, setCustomerInView} from "../../../actions";
import CMMC from "./routes/CMMC"
import NIST171 from "./routes/NIST-171";

function PageRoutes({match, betasOk, authUser}) {
    return(
        <Switch>
            {(isCurrentUserMemberOf(authUser, "admin")  || betasOk || bbDoesUserHaveAccessToModule(authUser, 7)) &&
            <Route path={`${match.url}/nist-171`}  component={NIST171}/>
            }
            {(isCurrentUserMemberOf(authUser, "admin") || betasOk || bbDoesUserHaveAccessToModule(authUser, 6)) &&
                <Route path={`${match.url}/cmmc`}  component={CMMC}/>
            }
            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        </Switch>
    );
}

const Pages = ({match}) => {
    const authUser = useSelector(({auth}) => auth.authUser);
    const {customerInView, customers} = useSelector(({customer}) => customer);
    const dispatch = useDispatch();
    const numCustomers = customers ? Object.keys(customers).length : 0;

    //TODO: The following appears to be causing jitter when the customers load or the start/stop attacks is pressed.
    useEffect( () => {
        if (customers == null && authUser) {
            console.log("Customers is empty, fetching from CIRTPages. numCustomers is ", numCustomers);
            dispatch(fetchCustomers());
        }
        if (numCustomers && customerInView === null) {
            const defaultId = getFirstCustomerId(customers);
            // console.log("setting view to default customer, first in list: ", defaultId);
            dispatch(setCustomerInView(defaultId));
        }
    }, [customers, dispatch]);


    const customer = customers ? customers[customerInView] : null;
    // console.log("customerInView is ", customerInView);

    //admins have access to all customers.  Other users may have multiple customers in their .customers array
    //users that have more than just a single customer need the multiboardwrapper to allow them to select the customer for display
    if (isCurrentUserMemberOf(authUser, "admin") || (!authUser.customers && !authUser.customers.isEmpty()) || (authUser.customers && authUser.customers.length > 1)) {
        return (
            <MultiBoardWrapper customer={customer} isAdmin={isCurrentUserMemberOf(authUser, "admin")}>
                <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)}/>
            </MultiBoardWrapper>
        )
    } else if (isCurrentUserMemberOf(authUser, "customer") && !isCurrentUserMemberOf(authUser, "admin")){
        return (
            <>
                <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)} authUser={authUser}/>
            </>
        )
    } else {
        return (
            <PageRoutes match={match} betasOk={bbIsBetasOk(authUser)}/>
        )
    }
};

export default Pages;
